import axios from 'axios'
import { config } from '../shared/app.config'

export default {
  getListOperarios(page, per_page, search, timestamp, user, client) {
    return axios.post(`${config.webApiBase}/users/list/operario`, {
      page,
      per_page,
      search,
      timestamp,
      user_id: user,
      client_id: client,
    })
  },
  generateMonthly(timestamp, clientId) {
    return axios.get(`${config.webApiBase}/users/pdf/monthly/${timestamp}/${clientId}`)
  },
  edit(user) {
    return axios.post(`${config.webApiBase}/journeyday/update`, user)
  },
}
